import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#5ABF6A"
        d="M4.6 13.733c1 .6 2.2.934 3.4.934 3.667 0 6.667-3 6.667-6.667s-3-6.667-6.667-6.667-6.667 3-6.667 6.667c0 1.2.334 2.333.867 3.333l-.573 2.204c-.13.5.332.95.828.81z"
      ></path>
      <path
        fill="#fff"
        d="M11 9.899a.8.8 0 0 1-.075.327 1.355 1.355 0 0 1-.697.66q-.27.113-.586.114-.46 0-.98-.219a5.3 5.3 0 0 1-1.033-.594 9 9 0 0 1-.986-.84 8.5 8.5 0 0 1-.838-.981 5.4 5.4 0 0 1-.589-1.023A2.5 2.5 0 0 1 5 6.362q0-.308.108-.579a1.4 1.4 0 0 1 .346-.501q.29-.283.625-.282c.084 0 .168.018.243.054a.5.5 0 0 1 .201.168l.697.981q.08.112.12.21a.5.5 0 0 1 .042.183.4.4 0 0 1-.063.213 1 1 0 0 1-.168.213l-.228.237a.16.16 0 0 0-.048.12q0 .034.009.069.014.035.024.06.08.15.28.384.201.235.435.474c.162.159.318.306.478.441q.234.196.387.276l.054.024a.2.2 0 0 0 .075.012q.075 0 .124-.051l.228-.225a1 1 0 0 1 .216-.168.4.4 0 0 1 .214-.063.5.5 0 0 1 .183.039q.098.04.21.117l.995.705a.46.46 0 0 1 .165.192c.03.075.048.15.048.234"
      ></path>
    </svg>
  );
};
